var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('video',{attrs:{"autoplay":"autoplay","muted":"","loop":"","src":this.getVideo,"type":"video/mp4"},domProps:{"muted":true}},[_vm._v(" This browser does not support the video tag. ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }